import Menu from "./menu";
import Option from "./option";

export interface IOrder {
  identifier: string;
  subIdentifier: string;
  name: string;
  quantity: number;
  orderTime: string; // it is jda_ins_date
  price: number;
  rowTotalPrice: number;
  isHaizen: string;
  menuDetail: Menu;
  options: any;
}
export class OrderDTO implements IOrder {
  identifier: string;
  name: string;
  quantity: number;
  orderTime: string;
  subIdentifier: string;
  price: number;
  rowTotalPrice: number;
  isHaizen: string;
  menuDetail: Menu;
  options: any;
  subMenus: Option[];
}

export default class Order extends OrderDTO {
  constructor(dto?: OrderDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      identifier: "",
      name: "",
      quantity: 0,
      orderTime: "",
      subIdentifier: "",
      price: "",
      rowTotalPrice: "",
      isHaizen: "",
      menuDetail: [],
      options: [],
    });
  }

  public getQuantity() {
    // let quantityResponse = 0;
    // if (this.options.length > 0) {
    //   this.options.map(option => {
    //     option.options.map(item => {
    //       quantityResponse = quantityResponse + item.quantity
    //     })
    //   })
    // }
    // return this.quantity + quantityResponse

    return this.quantity
  }
}
